import React from 'react';
import { Layout } from 'fronton-react';
import { Section } from '../section';
import { SectionSubTitle } from '../section-subtitle';
import { Typography } from '../typography';
import {
  reviewsDescription,
  reviewsSection,
  reviewsSectionTitle,
  reviewTextWrapper,
} from './reviews-section-styles';

type ReviewsSectionProp = {
  benefits?: React.ReactNode;
  description?: string;
  review: React.ReactNode;
  reviewTitle?: string;
  title?: string | React.ReactNode;
};

export const ReviewsSection: React.FC<ReviewsSectionProp> = ({ benefits, description, review, reviewTitle, title }) => (
  <Section className={reviewsSection}>
    <Layout>
      {title && (
        <SectionSubTitle className={reviewsSectionTitle} margin="l" color="text-invert">
          {title}
        </SectionSubTitle>
      )}
      {benefits}
      <div className={reviewTextWrapper}>
        <Typography variant="h2" color="text-invert">
          {reviewTitle ? reviewTitle : 'Отзывы клиентов'}
        </Typography>
        {description && (
          <Typography className={reviewsDescription} variant="l" size="body_long" color="text-invert">
            {description}
          </Typography>
        )}
      </div>
      {review}
    </Layout>
  </Section>
);
